module.exports = __webpack_public_path__ + "img/header-profile-skin-1.85efa900.png";